/* @ngInject */
function KanbanCardDateController ($scope, Utils) {
  $scope.formatedDate = moment($scope.task.deliveryDate).format('DD [de] MMM')
  $scope.colorPriority = {
    color: '#616161'
  }

  const api = {
    _validateTaskAge
  }
  this.getApi = () => api

  activate()

  function activate () {
    const daysDifference = Utils.daysUntilDelivery($scope.task.deliveryDate)

    if ($scope.task.status === 'DONE') {
      $scope.colorPriority.color = '#616161'
    } else if (daysDifference < 1) {
      $scope.colorPriority.color = '#B8002A'
    } else if (daysDifference === 1) {
      $scope.colorPriority.color = '#D6A622'
    }

    api._validateTaskAge($scope.task.createdAt)
  }

  function _validateTaskAge (createdAt) {
    const currentDate = new Date()
    const createdAtTime = new Date(createdAt)
    const timeDifference = currentDate - createdAtTime
    const taskAge = timeDifference / (1000 * 60 * 60 * 24)

    if (taskAge >= 365) {
      $scope.formatedDate = moment(createdAt).format('DD[/]MM[/]YY')
      $scope.colorPriority.color = '#616161'
    }
  }
}

export { KanbanCardDateController }
